import {FC} from 'react'
import {Modal} from 'react-bootstrap'
import {ModalHeader} from '_core/components/Modal'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import {setShowValidationMessageDialog} from 'app/features/orders/redux/shippingLabelError/shippingLabelErrorSlice'

type Props = {
  label?: string
}

const LabelValidationMessageDialog: FC<Props> = ({label}) => {
  const labelErrors = useSelector<RootState>(
    ({orders}) => orders.shippingLabelError.labelErrors
  ) as any[]
  const showValidationMessageDialog = useSelector<RootState>(
    ({orders}) => orders.shippingLabelError.showValidationMessageDialog
  ) as boolean

  const dispatch = useDispatch()

  const handleOpen = () => {
    dispatch(setShowValidationMessageDialog(true))
  }

  if (labelErrors.length === 0) {
    return null
  }

  return (
    <>
      <div className='ps-3'>
        <button className='btn btn-link text-danger' onClick={handleOpen}>
          {label ? label : 'Error occurred while creating the label. Please click to view more.'}
        </button>
      </div>

      <MessageDialog labelErrors={labelErrors} show={showValidationMessageDialog} />
    </>
  )
}

export default LabelValidationMessageDialog

type Props3 = {
  errors: any
}

export const LabelValidationMessageButton: FC<Props3> = ({errors}) => {
  const showValidationMessageDialog = useSelector<RootState>(
    ({orders}) => orders.shippingLabelError.showValidationMessageDialog
  ) as boolean

  const dispatch = useDispatch()

  const handleOpen = () => {
    dispatch(setShowValidationMessageDialog(true))
  }

  return (
    <>
      <button className='btn btn-link text-danger' onClick={handleOpen}>
        View more
      </button>

      <MessageDialog labelErrors={errors} show={showValidationMessageDialog} />
    </>
  )
}

type Props2 = {
  labelErrors: any[]
  show: boolean
}
const MessageDialog: FC<Props2> = ({show, labelErrors}) => {
  const dispatch = useDispatch()
  const handleClose = () => {
    dispatch(setShowValidationMessageDialog(false))
  }
  return (
    <Modal
      size='lg'
      id='shippingLabelValidationMessage'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='h-auto'
      show={show}
      centered
    >
      <ModalHeader
        title='Message'
        toolbar={{
          onClick: handleClose,
        }}
      />
      <div className='modal-body align-items-center'>
        <ul className='d-flex flex-column'>
          {labelErrors.map((error, index) => (
            <li key={index} className='py-1 '>
              <span className='text-danger fv-plugins-message-container invalid-feedback'>
                {error.message}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </Modal>
  )
}
